<template>
    <div class="full-width-type-select">
        <div class="title-span">
            <span tkey="產品類別">{{ i18n.tkey("lang_product_category") }}</span>
        </div>

        <div class="type-group-box">
            <button
                @click="changeTypeList('01')"
                :class="currTypeCode == '01' ? 'type-btn activate-type' : 'type-btn'"
                :disabled="readOnly === true"
                tkey="個人零售"
            >
                {{ i18n.tkey("lang_personal_retail") }}
            </button>

            <button
                @click="changeTypeList('00')"
                :class="currTypeCode == '00' ? 'type-btn activate-type' : 'type-btn'"
                :disabled="readOnly === true"
                tkey="商業貿易"
            >
                {{ i18n.tkey("lang_shopopee_trade") }}
            </button>

            <button
                @click="changeTypeList('02')"
                :class="currTypeCode == '02' ? 'type-btn activate-type' : 'type-btn'"
                :disabled="readOnly === true"
                tkey="服務"
            >
                {{ i18n.tkey("lang_serve") }}
            </button>

        </div>

        <div class="type-group-box">
            <el-select
                v-model="firstType"
                :placeholder="i18n.tkey('lang_select_pls')"
                size="large"
                style=""
                @change="changeFirstOption"
                :disabled="firstTypeList.length === 0 || readOnly === true"
            >
                <el-option
                    v-for="(item, i) in firstTypeList"
                    :key="item.bcatacode"
                    :label="item.langhk"
                    :value="i"
                />
            </el-select>

            <el-select
                    v-model="secondType"
                    :placeholder="i18n.tkey('lang_select_pls')"
                    size="large"
                    style=""
                    @change="changeSecondOption"
                    :disabled="secondTypeList.length === 0 || readOnly === true"
            >
                <el-option
                        v-for="(item, i) in secondTypeList"
                        :key="item.bcatacode"
                        :label="item.langhk"
                        :value="i"
                />
            </el-select>

            <el-select
                    v-model="thirdType"
                    :placeholder="i18n.tkey('lang_select_pls')"
                    size="large"
                    style=""
                    @change="changeThirdOption"
                    :disabled="thirdTypeList.length === 0 || readOnly === true"
            >
                <el-option
                        v-for="(item, i) in thirdTypeList"
                        :key="item.bcatacode"
                        :label="item.langhk"
                        :value="i"
                />
            </el-select>
        </div>
    </div>
</template>

<script setup>
import {toRef, ref, onMounted, computed, onUnmounted, inject} from "vue";
    import categoryApi from "@/request/categoryApi";

    const props = defineProps(["readOnly"])

    let allType = null

    const currTypeCode = ref("01")

    const firstTypeList = ref([])
    const secondTypeList = ref([])
    const thirdTypeList = ref([])

    const firstType = ref(null)
    const secondType = ref(null)
    const thirdType = ref(null)

    const inputObj = {}
    const i18n = inject("i18n")
    const emits = defineEmits(['onselectType'])

    function getAllType(callback) {
        const request = categoryApi.getAllProdutTypeWithOutType
        const params = request.getParams()

        request.send(params, callback)
    }

    function getTypeCallback(res) {
        if (res.code == 200){
            allType = res.detail
            fillTypeSelect()

            if (null != inputObj.type1){
                fillInputValue()
            }

        }else{
            allType = null
        }
    }
    
    function fillTypeSelect() {
        firstType.value = null
        secondType.value = null
        thirdType.value = null

        firstTypeList.value = []
        secondTypeList.value = []
        thirdTypeList.value = []

        if (currTypeCode.value == "00"){
            firstTypeList.value = allType.list00
        }else if (currTypeCode.value == "01"){
            firstTypeList.value = allType.list01
        }else {
            firstTypeList.value = allType.list02
        }
    }

    function changeTypeList(type) {
        currTypeCode.value = type
        fillTypeSelect()
    }

    function changeFirstOption(){
        const obj = firstTypeList.value[firstType.value]
        secondType.value = null
        thirdType.value = null
        thirdTypeList.value = []

        if (null != obj && null != obj.child){
            secondTypeList.value = obj.child
        }else{
            secondTypeList.value = []
        }
    }

    function changeSecondOption(){
        const obj = secondTypeList.value[secondType.value]
        thirdType.value = null

        if (null != obj && null != obj.child){
            thirdTypeList.value = obj.child
        }else{
            thirdTypeList.value = []
        }
    }
  function changeThirdOption(){

    emits("onselectType",getThirdType())
  }


    function getFirstType(){
        return firstTypeList.value[firstType.value]
    }

    function getSecondType(){
        return secondTypeList.value[secondType.value]
    }

    function getThirdType(){

        return thirdTypeList.value[thirdType.value]
    }

    function setTypeObj(type1, type2, type3){
        inputObj.type1 = type1
        inputObj.type2 = type2
        inputObj.type3 = type3

        if (firstTypeList.value.length > 0){
            fillInputValue()
        }
    }

    function fillInputValue(){
        changeTypeList(inputObj.type1.substring(0, 2))

        for (let i=0; i<firstTypeList.value.length; i++){
            const obj = firstTypeList.value[i]

            if (obj.bcatacode == inputObj.type1){
                firstType.value = i
                changeFirstOption()
                break;
            }

        }

        for (let i=0; i<secondTypeList.value.length; i++){
            const obj = secondTypeList.value[i]

            if (obj.bcatacode == inputObj.type2){
                secondType.value = i
                changeSecondOption()
                break;
            }

        }

        for (let i=0; i<thirdTypeList.value.length; i++){
            const obj = thirdTypeList.value[i]

            if (obj.bcatacode == inputObj.type3){
                thirdType.value = i
                break;
            }

        }
    }

    defineExpose({
        getFirstType,
        getSecondType,
        getThirdType,
        setTypeObj
    })

    onMounted(() => {
        getAllType(getTypeCallback)
    })
</script>

<style scoped>
    .full-width-type-select {
        width: 100%;
        text-align: left;
    }

    .title-span {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }

    .type-group-box {
        margin-bottom: 20px;
    }

    .type-btn {
        background-color: #dedfe0;
        color: #303133;
        padding: 10px;
        border: 0;
    }

    .type-btn+.type-btn {
        margin-left: 10px;
    }

    .activate-type {
        background-color: #008080;
        color: #FFFFFF;
    }
</style>